import React from 'react';

const AWS_Certificate = () => {
  return (
    <div>
      <h1>AWS_Certificate</h1>
      <p>This is the AWS_Certificate component.</p>
    </div>
  );
};

export default AWS_Certificate;
